export function insertScript(url) {
    const script = document.createElement('script');
    script.src = url;
    script.setAttribute('defer', '');
    document.head.appendChild(script);

    return script;
}
